<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper home">

        <!-- Header -->
        <layout-header />
        <!-- End Header -->

        <Hero />

        <Search />

        <HowTo />
        
        <!-- Banner -->
        <!-- <Banner /> -->
        <!-- Banner -->

        <!-- Coaching -->
        <!-- <Coaching /> -->
        <!-- Coaching -->

        <!-- Coaches -->
        <!-- <Coaches /> -->
        <!-- Coaches -->

        <!-- Golf Manner -->
        <!-- <GolfManner /> -->
        <!-- Golf Manner -->

        <!-- Testimonials -->
        <!-- <Testimonials /> -->
        <!-- Testimonials -->

        <!-- Blog -->
        <!-- <Blog /> -->
        <!-- Blog -->

        <!-- Features -->
        <Features />
        <!-- Features -->

        <!--<Partners />-->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->

    </div>
    <!-- /Main Wrapper -->
</template>

<script>
import Hero from '../Home/Hero'
import Search from '../Home/Search'
import HowTo from '../Home/HowTo'
import Features from '../Home/Features'
import Partners from '../Home/Partners'
import Testimonials from '../Home/Testimonials'
import Blog from '../Home/Blog'
export default {
    components: {
        Hero,
        Search,
        HowTo,
        Features,
        Partners,
        Testimonials,
        Blog
    },
    mounted() {
        $(document).ready(function () {
            // $('#filter-date').datetimepicker({
            //     minDate: new Date(),
            //     format: 'DD/MM/YYYY',
            //     icons: {
            //         up: "fas fa-chevron-up",
            //         down: "fas fa-chevron-down",
            //         next: 'fas fa-chevron-right',
            //         previous: 'fas fa-chevron-left'
            //     }
            // })
        })
    }
}
</script>
